import { motion } from "framer-motion";

const components = [
  { n: "01", name: "Polymer Sealant Matrix", pct: "42%", desc: "Skin-flexible film former that bonds to tissue edges." },
  { n: "02", name: "Bioactive Peptide Complex", pct: "18%", desc: "Signals cellular repair and collagen synthesis." },
  { n: "03", name: "Botanical Antiseptics", pct: "15%", desc: "Plant-derived antimicrobial shield." },
  { n: "04", name: "Humectant Carrier Base", pct: "25%", desc: "Maintains an optimal moist healing environment." },
];

export const Formulation = () => (
  <section id="formulation" className="py-24 md:py-32 relative bg-muted/40" data-testid="formulation-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex items-baseline gap-4 mb-8">
        <span className="font-serifaccent italic text-secondary text-6xl md:text-7xl leading-none">01</span>
        <div>
          <span className="font-monotech text-xs tracking-[0.25em] uppercase text-text-muted">Chapter</span>
          <h2 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-primary leading-none">
            Formulation
          </h2>
        </div>
      </div>
      <p className="text-text-muted text-base md:text-lg leading-relaxed max-w-2xl mb-14">
        Every batch of Healseeal is compounded in an ISO-controlled facility. Our formula
        balances a fast-setting seal with a nourishing bioactive layer — precise ratios that
        protect the wound while the body does what it does best.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {components.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="border border-border bg-card rounded-2xl p-6 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
            data-testid={`formulation-component-${i}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="font-monotech text-xs text-text-muted">{c.n}</span>
              <span className="font-heading font-bold text-3xl text-clinic">{c.pct}</span>
            </div>
            <h3 className="font-heading font-bold text-lg text-primary leading-tight">{c.name}</h3>
            <p className="text-sm text-text-muted mt-1.5">{c.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
